export default "<h1>{{title}}</h1>\n<p>\n  manage-pages works!\n</p>\n"